import React from 'react';
import { getDesignSystemIcon } from '@phoenix/design-system/frontend/util/path.utils';
import { useDealerMapContext } from '../context/dealer-map-context';
import { useRouter } from 'next/router';
import { link } from '../../../util/navigation/link.utils';
import { useTranslation } from 'next-i18next';
import { useDealerListContext } from '../context/dealer-list-context';
import { cn } from '@phoenix/design-system/frontend/util/classNameUtils';

export const DealerDetailsBackButton = React.forwardRef<HTMLButtonElement, { isStandalone: boolean }>(({ isStandalone }, ref) => {
  const { setSelectedDealer } = useDealerMapContext();
  const { activeTab } = useDealerListContext();
  const { t } = useTranslation(['shared']);
  const router = useRouter();

  if (isStandalone) {
    return null;
  }

  return (
    <button
      type="button"
      ref={ref}
      onClick={() => {
        router.push(link(`/profile/dealers`), undefined, { shallow: true });
        setSelectedDealer?.(undefined);
      }}
      className={cn(
        'absolute left-3 top-6 block bg-transparent',
        'focus-visible:outline-offset-0 focus-visible:outline-[#252525] focus-visible:outline-[2px] focus-visible:outline'
      )}
    >
      <svg className="h-6 w-6 text-current" data-testid="dealer-details_button-back">
        <use xlinkHref={getDesignSystemIcon('icon-chevron-left.svg') + '#img'} />
      </svg>
      <span className="sr-only">
        {activeTab === 0 ? t('shared_dealers_buttonBackFavorites_aria') : t('shared_dealers_buttonBackResults_aria')}
      </span>
    </button>
  );
});
